import { useParams, useNavigate } from 'react-router-dom';
import { Button, Card, Text, Stack } from '@mantine/core';
import PageHeader from '../../../components/shared/PageHeader';

export default function ExportSession() {
  const { id } = useParams();
  const navigate = useNavigate();

  const handleExport = () => {
    alert('Hello World');
  };

  return (
    <div
      style={{
        position: 'relative',
        minHeight: 'calc(100vh - 85px)',
        display: 'flex',
        flexDirection: 'column',
        padding: '1rem',
        boxSizing: 'border-box',
      }}
    >
      <PageHeader
        title='Esporta sessione'
        subtitle={`Esporta i dati della sessione #${id}`}
        breadcrumbs={[
          {
            label: 'Tutte le sessioni',
            onClick: () => navigate('/sessions'),
          },
          {
            label: 'Sessioni completate',
            onClick: () => navigate('/sessions/completed'),
          },
          {
            label: `Sessione #${id}`,
            onClick: () => navigate(`/sessions/completed/${id}`),
          },
          {
            label: 'Esporta',
          },
        ]}
        backUrl={`/sessions/completed/${id}`}
      />

      <Card shadow='sm' withBorder p='md' radius='sm' mt='md'>
        <Stack gap='md'>
          <Text>Funzionalità di esportazione in fase di sviluppo.</Text>
          <Button onClick={handleExport}>Esporta CSV</Button>
        </Stack>
      </Card>
    </div>
  );
}
